import {
  Database,
  Server,
  BarChart3,
  Activity,
  Gauge,
  FileText,
  Compass,
  Search,
  UserCheck,
  Users,
  Shield,
  HelpCircle,
  TrendingUp,
  LucideIcon,
} from 'lucide-react';

/** Accent colour shared by a category and every tool inside it. */
export type CategoryColor = 'rose' | 'teal' | 'blue';

/** A single tool tile rendered inside a category card. */
export interface HomeTool {
  id: string;
  title: string;
  route: string;
  icon: LucideIcon;
}

/** A category card on the home workbench. */
export interface HomeCategory {
  id: string;
  title: string;
  icon: LucideIcon;
  color: CategoryColor;
  tools: HomeTool[];
}

/**
 * Data-driven home workbench — categories map to cards, tools map to rows.
 * Mirrors the osdu-insights "My Reports" tile layout.
 */
export const HOME_CATEGORIES: HomeCategory[] = [
  {
    id: 'entitlements',
    title: 'Entitlements',
    icon: Shield,
    color: 'rose',
    tools: [
      { id: 'check-membership', title: 'Check Membership', route: '/operations/check-membership', icon: UserCheck },
      { id: 'groups', title: 'All Groups', route: '/groups', icon: Users },
      { id: 'service-groups', title: 'Permission Guide', route: '/service-groups', icon: HelpCircle },
    ],
  },
  {
    id: 'data',
    title: 'Data',
    icon: Database,
    color: 'teal',
    tools: [
      { id: 'data-explorer', title: 'Data Explorer', route: '/data-explorer', icon: Compass },
      { id: 'search', title: 'Search Records', route: '/search', icon: Search },
    ],
  },
  {
    id: 'platform',
    title: 'Platform',
    icon: Server,
    color: 'blue',
    tools: [
      { id: 'monitoring', title: 'Data Monitoring', route: '/monitoring', icon: BarChart3 },
      { id: 'active-users', title: 'Active Users', route: '/active-users', icon: TrendingUp },
      { id: 'logs', title: 'ADME Logs', route: '/logs', icon: FileText },
      { id: 'api-health', title: 'API Health', route: '/api-health', icon: Gauge },
      { id: 'health', title: 'System Health', route: '/health', icon: Activity },
    ],
  },
];

/** Tailwind classes per category accent colour. Mirrors osdu-insights tiles. */
export const CATEGORY_COLORS: Record<
  CategoryColor,
  { iconBg: string; iconText: string; toolIcon: string }
> = {
  rose: {
    iconBg: 'bg-rose-500/15 dark:bg-rose-400/15 ring-1 ring-rose-500/20 dark:ring-rose-400/20',
    iconText: 'text-rose-600 dark:text-rose-400',
    toolIcon: 'text-rose-400',
  },
  teal: {
    iconBg: 'bg-teal-500/15 dark:bg-teal-400/15 ring-1 ring-teal-500/20 dark:ring-teal-400/20',
    iconText: 'text-teal-600 dark:text-teal-400',
    toolIcon: 'text-teal-500',
  },
  blue: {
    iconBg: 'bg-blue-500/15 dark:bg-blue-400/15 ring-1 ring-blue-500/20 dark:ring-blue-400/20',
    iconText: 'text-blue-600 dark:text-blue-400',
    toolIcon: 'text-blue-500',
  },
};
